export const achievementData = {
    achievements : [
        {
            id : 1,
            title : 'Google Data Analytics Certificate',
            details : 'This certificate validates my skills in data analysis, showcasing expertise in using SQL, R, and spreadsheets to process, clean, visualize data, and generate actionable insights.',
            date : 'Jan 19, 2025',
            field : 'Data Analysis',
            image : 'https://cdn.shopaccino.com/igmguru/articles/Data-Analytics-Tutorial-1-900x558.jpg'
        },
        {
            id : 2,
            title : 'Google UX Design Certificate',
            details : 'This Certificate validates my skills in user-centered design, showcasing my ability to create intuitive, accessible digital products through research, prototyping, and usability testing, helping businesses enhance user experiences.',
            date : 'Oct 07, 2024',
            field : 'UX/UI Design',
            image : 'https://static.guvi.in/course-thumbnail/webps/figmaenglish.webp'
        },
        {
            id : 3,
            title : 'AWS Academy Cloud Foundations',
            details : 'It validates my foundational knowledge of cloud computing concepts and AWS services. It showcases my ability to understand core AWS services, architecture, and cloud security.',
            date : 'May 28, 2023',
            field : 'Cloud',
            image : 'https://blog.educacionit.com/wp-content/uploads/2020/09/AWS.jpg'
        },
    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/